import { render } from "./EmailPanel.vue?vue&type=template&id=648efcd1&scoped=true"
import script from "./EmailPanel.vue?vue&type=script&lang=js"
export * from "./EmailPanel.vue?vue&type=script&lang=js"

import "./EmailPanel.vue?vue&type=style&index=0&id=648efcd1&lang=scss&scoped=true"
import "./EmailPanel.vue?vue&type=style&index=1&id=648efcd1&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-648efcd1"]])

export default __exports__